import { 
      redThemeLight} from '../theme/theme'


export const themeData = {
    theme: redThemeLight,
}



